import React from "react";
import {
  home1,
  home2,
  home3,
  home4,
  home5,
  home6,
  home7,
  home8,
  home9,
  home10,
} from "../../../Utils/Images/home-images";

function HeroGrid() {
  return (
    <div className="tiles__wrap">
      <div
        className="tiles__line"
        data-scroll
        data-scroll-speed="1"
        data-scroll-target="#grid"
      >
        <div
          className="tiles__line-img"
          style={{ backgroundImage: `url(${home5})` }}
        ></div>
        <div
          className="tiles__line-img"
          style={{ backgroundImage: `url(${home9})` }}
        ></div>
        <div
          className="tiles__line-img"
          style={{ backgroundImage: `url(${home6})` }}
        ></div>
        <div
          className="tiles__line-img"
          style={{ backgroundImage: `url(${home2})` }}
        ></div>
        <div
          className="tiles__line-img"
          style={{ backgroundImage: `url(${home3})` }}
        ></div>
      </div>
      <div
        className="tiles__line"
        data-scroll
        data-scroll-speed="-1"
        data-scroll-target="#grid"
      >
        <div
          className="tiles__line-img"
          style={{ backgroundImage: `url(${home6})` }}
        ></div>
        <div
          className="tiles__line-img"
          style={{ backgroundImage: `url(${home7})` }}
        ></div>
        <div
          className="tiles__line-img"
          style={{ backgroundImage: `url(${home8})` }}
        ></div>
        <div
          className="tiles__line-img"
          style={{ backgroundImage: `url(${home9})` }}
        ></div>
        <div
          className="tiles__line-img"
          style={{ backgroundImage: `url(${home10})` }}
        ></div>
      </div>
      <div
        className="tiles__line"
        data-scroll
        data-scroll-speed="1"
        data-scroll-target="#grid"
      >
        <div
          className="tiles__line-img"
          style={{ backgroundImage: `url(${home1})` }}
        ></div>
        <div
          className="tiles__line-img"
          style={{ backgroundImage: `url(${home2})` }}
        ></div>
        <div
          className="tiles__line-img"
          style={{ backgroundImage: `url(${home3})` }}
        ></div>
        <div
          className="tiles__line-img"
          style={{ backgroundImage: `url(${home10})` }}
        ></div>
        <div
          className="tiles__line-img"
          style={{ backgroundImage: `url(${home9})` }}
        ></div>
      </div>
      <div
        className="tiles__line"
        data-scroll
        data-scroll-speed="-1"
        data-scroll-target="#grid"
      >
        <div
          className="tiles__line-img"
          style={{ backgroundImage: `url(${home7})` }}
        ></div>
        <div
          className="tiles__line-img"
          style={{ backgroundImage: `url(${home8})` }}
        ></div>
        <div
          className="tiles__line-img"
          style={{ backgroundImage: `url(${home1})` }}
        ></div>
        <div
          className="tiles__line-img"
          style={{ backgroundImage: `url(${home5})` }}
        ></div>
        <div
          className="tiles__line-img"
          style={{ backgroundImage: `url(${home6})` }}
        ></div>
      </div>
      <div
        className="tiles__line"
        data-scroll
        data-scroll-speed="1"
        data-scroll-target="#grid"
      >
        <div
          className="tiles__line-img"
          style={{ backgroundImage: `url(${home2})` }}
        ></div>
        <div
          className="tiles__line-img"
          style={{ backgroundImage: `url(${home3})` }}
        ></div>
        <div
          className="tiles__line-img"
          style={{ backgroundImage: `url(${home4})` }}
        ></div>
        <div
          className="tiles__line-img"
          style={{ backgroundImage: `url(${home5})` }}
        ></div>
        <div
          className="tiles__line-img"
          style={{ backgroundImage: `url(${home6})` }}
        ></div>
      </div>
    </div>
  );
}

export default HeroGrid;
